var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-document mt-3"},[(_vm.fileExtension == 'pdf')?_c('RomaPDF',{attrs:{"pdfDoc":_vm.src}}):(
      _vm.fileExtension != 'pdf' &&
      _vm.fileExtension != 'jpg' &&
      _vm.fileExtension != 'png' &&
      _vm.fileExtension != 'jpeg'
    )?_c('iframe',{staticClass:"responsive-iframe",attrs:{"src":("https://docs.google.com/gview?url=" + _vm.link + "&embedded=true"),"frameborder":"0","allow":"accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}}):_c('div',{staticClass:"img-container"},[_c('img',{attrs:{"src":_vm.link}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }